import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Space, Button, Modal, Input, message, Spin } from "antd";
import { isLogged, getAuthToken } from "../../../../../helpers/account";
import { api } from "../../../../../config/api";
import { useDispatch } from "react-redux";

const NewRewardForm = () => {
  const { t } = useTranslation();
  const [newRewardModalOpen, setNewRewardModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "", // Separate state variable for bank name
    code: "", // Separate state variable for account number
    value: "", // Separate state variable for account number
  });
  const dispatch = useDispatch();
  const handleCreateNewReward = () => {
    if (validateFormData()) {
      setLoading(true);
      // Sending data using API
      const apiData = {
        name: formData.name,
        code: formData.code,
        value: formData.value,
      };

      const apiUrl = `${api.host}/rewards`;

      if (isLogged()) {
        // Fetch bank account data from the API
        fetch(apiUrl, {
          method: "POST",
          headers: new Headers({
            "Content-Type": "application/json",
            Authorization: `${getAuthToken()}`,
          }),
          body: JSON.stringify(apiData), // Send the data in the request body
        })
          .then((response) => response.json())
          .then((data) => {
            setLoading(false);
            dispatch({
              type: "bankAccountsListUpdated",
              payload: {
                bankAccountsListUpdated: new Date().getSeconds(),
              },
            });
            message.success(t('reward.form.newCardAdded'));
            setNewRewardModalOpen(false);
            setFormData({
              name: "", // Separate state variable for bank name
              code: "", // Separate state variable for account number
              value: "", // Separate state variable for account number
            });
          })
          .catch((error) => {
            setLoading(false);
            console.error("Error while creating reward data:", error);
          });
      }
    }
  };

  const validateFormData = () => {
    // Data validation
    if (!formData.name || !formData.code || !formData.value) {
      message.error(t('reward.form.allFieldsRequired'));
      return false;
    }

    return true;
  };

  const handleNewReward = () => {
    setNewRewardModalOpen(true);
  };

  const handleCancelNewReward = () => {
    setNewRewardModalOpen(false);
  };

  return (
    <>
      <Spin spinning={loading}>
        <Button
          onClick={handleNewReward}
          type="primary"
          size="large"
          style={{ 
            width: "100%", 
            maxWidth: "400px",
            height: "56px",
            fontSize: "18px",
            fontWeight: "600"
          }}
        >
          🎁 {t('reward.form.newCard')}
        </Button>

        <Modal
          title={t('reward.form.newGiftCard')}
          open={newRewardModalOpen}
          onOk={handleCreateNewReward}
          onCancel={handleCancelNewReward}
          okText={t('common.add')}
          cancelText={t('common.cancel')}
        >
          <Space size={15} direction="vertical" style={{ width: "100%" }}>
            <Input
              placeholder={t('reward.form.cardName')}
              onChange={
                (e) => setFormData({ ...formData, name: e.target.value }) // Use separate state variable
              }
              value={formData.name} // Use separate state variable
            />

            <Input
              placeholder={t('reward.form.cardCode')}
              onChange={
                (e) => setFormData({ ...formData, code: e.target.value }) // Use separate state variable
              }
              value={formData.code} // Use separate state variable
            />

            <Input
              placeholder={t('reward.form.value')}
              onChange={
                (e) => setFormData({ ...formData, value: e.target.value }) // Use separate state variable
              }
              value={formData.value} // Use separate state variable
            />

            <p style={{fontSize:"80%"}}>
              {t('reward.form.ownershipDeclaration')}
            </p>
          </Space>
        </Modal>
      </Spin>
    </>
  );
};

export default NewRewardForm;
